<template>
	<v-dialog scrollable persistent v-model="dialog" @click:outside="closeDialog()" @keyup.esc="closeDialog()" :value="dialogVisible" max-width="600">
		<v-card>
			<v-card-title>
				Przekierowanie na zewnętrzny adres
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="font-14">
				Ten link prowadzi na zewnętrzną stronę: <span class="text-accent">{{ url }}</span>.
				<br>Na pewno chcesz tam przejść?
			</v-card-text>
			<v-card-actions class="justify-content-right py-3 px-6 mb-3">
				<v-btn @click="closeDialog()">Zostań na tej stronie</v-btn>
				<v-btn :href="url" target="_blank" color="accent">Tak, chcę przejść</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		url: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			dialog: true,
			dialogVisible: true
		}
	},
	methods: {
		closeDialog() {
			this.$store.commit('application/closeLeave');
		},
		goToUrl() {
			location.href = this.url;
		}
	}
}
</script>